// src/components/EnhancedMergelyDiff.js
import React, { useEffect, useRef, useState } from "react";
import Mergely from "mergely-react";
import "../EnhancedMergelyDiff.css"; // CSS file in src/

// Helper: format JSON with 2-space indentation.
const formatJSON = (jsonStr) => {
  try {
    return JSON.stringify(JSON.parse(jsonStr), null, 2);
  } catch (e) {
    return jsonStr;
  }
};

const EnhancedMergelyDiff = ({ lhs, rhs }) => {
  const mergelyRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);

  // Update the diff when lhs or rhs change.
  useEffect(() => {
    if (mergelyRef.current) {
      const editor = mergelyRef.current.editor();
      if (editor && typeof editor.setChanges === "function") {
        editor.setChanges({
          lhs: formatJSON(lhs),
          rhs: formatJSON(rhs),
        });
      }
    }
  }, [lhs, rhs]);

  // Dummy pagination: scroll the Mergely container.
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    const editor = mergelyRef.current && mergelyRef.current.editor();
    if (editor && editor.dom) {
      const container = editor.dom;
      const totalHeight = container.scrollHeight;
      // Assume 10 pages (adjust as needed)
      const newScrollTop = ((newPage - 1) / 10) * totalHeight;
      container.scrollTop = newScrollTop;
    }
  };

  // Dummy action handlers.
  const handleMergeLeftToRight = () =>
    alert("Merge Left → Right triggered (implement merge logic)");
  const handleMergeRightToLeft = () =>
    alert("Merge Right → Left triggered (implement merge logic)");
  const handleMerge = () => alert("Merge action triggered");
  const handleUndo = () => alert("Undo action triggered");
  const handleSave = () => alert("Save action triggered");
  const handleSaveAndNext = () => alert("Save & Next action triggered");
  const handleExport = () => alert("Export action triggered");

  return (
    <div className="enhanced-diff-container">
      {/* Controls Section */}
      <div className="diff-controls">
        <div className="filters">
          <label>
            <input type="checkbox" defaultChecked /> Changed Lines
          </label>
          <label>
            <input type="checkbox" defaultChecked /> New Lines
          </label>
          <label>
            <input type="checkbox" defaultChecked /> Missing Lines
          </label>
        </div>
        <div className="actions">
          <button onClick={handleMergeLeftToRight}>Merge L → R</button>
          <button onClick={handleMergeRightToLeft}>Merge R → L</button>
          <button onClick={handleMerge}>Merge</button>
          <button onClick={handleUndo}>Undo</button>
          <button onClick={handleSave}>Save</button>
          <button onClick={handleSaveAndNext}>Save & Next</button>
          <button onClick={handleExport}>Export</button>
        </div>
      </div>
      {/* Mergely Diff Editor */}
      <div className="mergely-diff-editor">
        <Mergely
          ref={mergelyRef}
          lhs={formatJSON(lhs)}
          rhs={formatJSON(rhs)}
          options={{
            wrap_lines: true,
            license: "",
            cmsettings: {
              lineNumbers: true,
              lineWrapping: true,
            },
          }}
        />
      </div>
      {/* Pagination Section */}
      <div className="pagination-section">
        <button
          onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button onClick={() => handlePageChange(currentPage + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default EnhancedMergelyDiff;